import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dash-panel" }
const _hoisted_2 = { class: "dash-panel-head" }
const _hoisted_3 = {
  key: 0,
  class: "dash-chip"
}
const _hoisted_4 = {
  key: 1,
  class: "dash-empty"
}
const _hoisted_5 = { class: "role-main" }
const _hoisted_6 = { class: "role-line" }
const _hoisted_7 = { class: "role-name" }
const _hoisted_8 = { class: "role-value" }
const _hoisted_9 = { class: "role-track" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, [
        _createElementVNode("span", { class: "dash-eyebrow" }, "Équipe"),
        _createElementVNode("h3", { class: "dash-panel-title" }, "Utilisateurs par rôle"),
        _createElementVNode("p", { class: "dash-panel-sub" }, "Répartition actuelle des comptes")
      ], -1)),
      (_ctx.total)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.total.toLocaleString("fr-FR")) + " au total", 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isLoader && !_ctx.roles.length)
      ? (_openBlock(), _createBlock(_component_AppLoader, {
          key: 0,
          variant: "skeleton",
          rows: 5
        }))
      : (!_ctx.total)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              class: "ph ph-users",
              "aria-hidden": "true"
            }, null, -1),
            _createElementVNode("p", null, "Aucun utilisateur.", -1)
          ])))
        : (_openBlock(), _createElementBlock("ul", {
            key: 2,
            class: _normalizeClass(["role-list", { 'is-refreshing': _ctx.isLoader }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: role.label,
                class: "role-row"
              }, [
                _createElementVNode("span", {
                  class: "role-dot",
                  style: _normalizeStyle({ background: role.color })
                }, null, 4),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(role.label), 1),
                    _createElementVNode("span", _hoisted_8, [
                      _createTextVNode(_toDisplayString(role.value.toLocaleString("fr-FR")) + " ", 1),
                      _createElementVNode("small", null, _toDisplayString(role.share) + "%", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", {
                      class: "role-bar",
                      style: _normalizeStyle({ '--w': role.width + '%', '--d': index * 60 + 'ms', background: role.color })
                    }, null, 4)
                  ])
                ])
              ]))
            }), 128))
          ], 2))
  ]))
}